
import PlaceIcon from '@mui/icons-material/Place';
import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Grid,
    Stack,
    Typography
} from "@mui/material";

const SuggestionsPanel = ({
    suggestions,
    currentList,
    onAdd
}) => {

    const existsInList = (item) => {

        return currentList.some(
            x =>
                x.collegeCode === item.collegeCode &&
                x.branch === item.branch
        );
    };
    console.log("SuggestionsPanel Rendered", { suggestions, currentList });

    return (
        <Grid container spacing={2}>

            {suggestions.map(item => {

                const alreadyAdded =
                    existsInList(item);

                return (
                    <Grid
                        item
                        xs={12}
                        md={6}
                        lg={4}
                        key={item.id}
                    >

                        <Card
                            sx={{
                                height: "100%"
                            }}
                        >
                            <CardContent>
                                {/* TOP SECTION */}
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    mb={1}
                                >
                                    <Chip
                                        label={item.status}
                                        style={{
                                            fontFamily: 'Poppins',
                                            backgroundColor:
                                                item.status === "High Chance"
                                                    ? '#d1fae5'
                                                    : item.status === "Moderate Chance"
                                                        ? '#fef3c7'
                                                        : '#fee2e2',
                                            color:
                                                item.status === "High Chance"
                                                    ? '#065f46'
                                                    : item.status === "Moderate Chance"
                                                        ? '#92400e'
                                                        : '#991b1b'
                                        }}
                                        size="small"
                                    />

                                    {/* LOCATION MOVED HERE */}
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            fontSize: {
                                                xs: "0.75rem",
                                                sm: "0.85rem"
                                            }
                                        }}
                                    >
                                        <PlaceIcon fontSize="small" />
                                        {item.city}
                                    </Typography>
                                </Stack>

                                {/* COLLEGE NAME */}
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    textAlign="left"
                                    sx={{
                                        fontSize: {
                                            xs: "1rem",
                                            sm: "1.1rem"
                                        },
                                        fontWeight: 600,
                                        wordBreak: "break-word"
                                    }}
                                >
                                    {item.college}
                                </Typography>

                                {/* BOTTOM ROW */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-end",
                                        gap: 2,
                                        mt: 1
                                    }}
                                >
                                    {/* BRANCH + SEATS */}
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            lineHeight: 1.6,
                                            wordBreak: "break-word",
                                            flex: 1,
                                            textAlign: "left",
                                        }}
                                    >
                                        {item.branch} &nbsp; Overall seats: {" "} {item.seats} {item.totalSeats != null && ` / ${item.totalSeats}`}
                                    </Typography>

                                    {/* BUTTON MOVED HERE */}
                                    <Button
                                        variant={
                                            alreadyAdded
                                                ? "outlined"
                                                : "contained"
                                        }
                                        disabled={alreadyAdded}
                                        onClick={() => onAdd(item)}
                                        sx={{
                                            backgroundColor: alreadyAdded
                                                ? '#E5E7EB'
                                                : '#002147',
                                            color: '#fff',
                                            fontFamily: 'Poppins',
                                            textTransform: 'none',
                                            whiteSpace: "nowrap",
                                            minWidth: "fit-content",
                                            alignSelf: "flex-end",
                                            '&:hover': {
                                                backgroundColor: alreadyAdded ? '#E5E7EB' : '#00152e',
                                            },

                                            '&.Mui-disabled': {
                                                backgroundColor: '#E5E7EB',
                                                color: '#6B7280',
                                                borderColor: '#CBD5E1',
                                            }
                                        }}
                                    >
                                        {alreadyAdded
                                            ? "Added"
                                            : "Add to Preference"}
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>

                    </Grid>
                );
            })}

        </Grid>
    );
};

export default SuggestionsPanel;